module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0015392_banner.67af6d8c.png";